<template>
	<GlassCard id="recent-meals">
		<h2 class="p-3">Recent Meals/Drinks</h2>
		<div class="swiper-container p-3">
			<div v-if="loading">Loading meals/drinks...</div>
			<food-swiper :meals="recentMeals" />
		</div>
	</GlassCard>
</template>

<script setup>
	import { ref, onMounted, watch, onBeforeMount, onBeforeUnmount } from "vue"
	import FoodSwiper from "@/components/FoodSwiper.vue"
	import GlassCard from "./GlassCard.vue"
	import { useTokenStore } from "@/stores/token"
	// import { useRouter } from "vue-router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import {
	// 	lastMealUpdated,
	// 	lastMealDeleted,
	// 	lastMealAdded,
	// } from "@/utils/mealBus"
	import EventBus from "@/utils/eventBus"
	// import { useUserStore } from "@/stores/user"

	// const userStore = useUserStore()

	// const props = defineProps({ user: Object })
	const recentMeals = ref([])
	const loading = ref(true)

	// const router = useRouter()
	const tokenStore = useTokenStore()

	const fetchMeals = async () => {
		loading.value = true
		try {
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth("/api/get-recent-meals", {
				method: "GET",
				headers: {
					"User-Timezone": tz,
					// Authorization: `Bearer ${tokenStore.token}`,
				},
			})

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			if (!response.ok) {
				throw new Error("Failed to fetch")
			}
			recentMeals.value = await response.json()
			// }
		} catch (error) {
			console.error("Error fetching meals:", error)
		} finally {
			loading.value = false
		}
	}

	onMounted(() => {
		fetchMeals()
	})

	// watch(lastMealUpdated, (v) => {
	// 	if (!v) return
	// 	// console.log("lastMealUpdated", v)
	// 	//check to see if the new one that updated is our id and if it is, updated it
	// 	const index = recentMeals.value.findIndex((a) => a.id === v.id)
	// 	if (index > -1) {
	// 		recentMeals.value[index] = v
	// 	} else {
	// 		//maybe it is a newer item?
	// 		const first = recentMeals.value[0].timestamp
	// 		const diff = first - v.timestamp
	// 		if (diff <= 0) {
	// 			//this was just added!
	// 			//add to the front of the array
	// 			recentMeals.value.unshift(v)
	// 		}
	// 	}
	// })

	// watch(lastMealDeleted, (v) => {
	// 	if (!v) return
	// 	//check to see if the new one that updated is our id and if it is, updated it
	// 	const index = recentMeals.value.findIndex((a) => a.id === v.id)
	// 	if (index > -1) {
	// 		// recentMeals.value[index] = v
	// 		recentMeals.value.splice(index, 1)
	// 	}
	// })

	// watch(
	// 	lastMealAdded,
	// 	(v) => {
	// 		if (!v || v.length === 0) return

	// 		// recentMeals.value.unshift(...v)
	// 		// console.log("lastMealUpdated", v)

	// 		// Filter out elements from v that already exist in recentMeals
	// 		const newItems = v.filter(
	// 			(item) => !recentMeals.value.some((meal) => meal.id === item.id)
	// 		)
	// 		recentMeals.value.unshift(...newItems)

	// 		const filtered = lastMealAdded.value.filter(
	// 			(f) => !v.some((item) => item.id === f.id)
	// 		)

	// 		// console.log("IN HERE", v, lastMealAdded.value, filtered)
	// 		lastMealAdded.value = filtered
	// 		// console.log("AFTER ASSIGN", lastMealAdded.value)
	// 	},
	// 	{
	// 		deep: true,
	// 	}
	// )

	let offMealUpdated = null
	let offMealDeleted = null
	let offMealAdded = null

	onBeforeMount(() => {
		offMealUpdated = EventBus.on("meal-updated", (meal) => {
			if (!meal) return
			// console.log("meal-updated", meal)
			//check to see if the new one that updated is our id and if it is, updated it
			const index = recentMeals.value.findIndex((a) => a.id === meal.id)
			if (index > -1) {
				recentMeals.value[index] = meal
			} else {
				//maybe it is a newer item?
				const first = recentMeals.value[0]?.timestamp
				const diff = first - meal.timestamp
				if (diff <= 0) {
					//this was just added!
					//add to the front of the array
					recentMeals.value.unshift(meal)
				}
			}
		})

		offMealDeleted = EventBus.on("meal-deleted", (meal) => {
			if (!meal) return
			//check to see if the new one that updated is our id and if it is, updated it
			const index = recentMeals.value.findIndex((a) => a.id === meal.id)
			if (index > -1) {
				// recentMeals.value[index] = v
				recentMeals.value.splice(index, 1)
			}
		})

		offMealAdded = EventBus.on("meal-added", (meal) => {
			if (!meal) return
			// if not in recentMeals, add it
			if (recentMeals.value.some((m) => m.id === meal.id)) return
			recentMeals.value.unshift(meal)
		})
	})

	onBeforeUnmount(() => {
		if (offMealUpdated) offMealUpdated()
		if (offMealDeleted) offMealDeleted()
		if (offMealAdded) offMealAdded()
	})
</script>

<style lang="less" scoped>
	#recent-meals {
		border-radius: 8px;
	}
</style>
